import { HPLC_BLUEPRINT } from "./hplc";
/** Every blueprint a method can be created from, by id. */
export const TEST_BLUEPRINTS = {
    [HPLC_BLUEPRINT.id]: HPLC_BLUEPRINT,
};
export function getTestBlueprint(id) {
    return (id && TEST_BLUEPRINTS[id]) || null;
}
//# sourceMappingURL=registry.js.map